import { render, staticRenderFns } from "./GenerandoCatalogo.vue?vue&type=template&id=4fb8ef26"
import script from "./GenerandoCatalogo.vue?vue&type=script&lang=js"
export * from "./GenerandoCatalogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports